import React from 'react'
import { Icon } from '@mui/material'

export const CustomIcon = ({ src }) => (
    <Icon style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img src={src} alt='wazeICON' height={20} width={20} />
    </Icon>
)
